import { centroid } from '@turf/turf'

export function getPolygonCenter(geometry: any) {
  // geometry é seu objeto GeoJSON
  const center = centroid(geometry)

  const [lon, lat] = center.geometry.coordinates

  return { centerLat: lat, centerLon: lon }
}
